<template>
  <div class="detailed-container">
    <div class="content">
      <img id="containerImg" src="https://cdn.discordapp.com/attachments/966183349318189086/971090201726287973/MG-Container-800pxReverse.gif" />
      <p id="nameP">{{ containerNFTInfo.name }}</p>

      <v-row id="tabRow">
        <v-col sm="6" class="left" :class="isDetailDesc ? 'active' : ''" @click="() => { isDetailDesc = true; }">
          <p id="descP">Description</p>
          <div id="arrowDiv" :style="[isDetailDesc ? {'display': 'inherit'} : {'display': 'none'}]"></div>
        </v-col>
        <v-col sm="6" class="right" :class="isDetailDesc ? '' : 'active'" @click="() => { isDetailDesc = false; }">
          <p id="attribP">Attributes</p>
          <div id="arrowDiv" :style="[isDetailDesc ? {'display': 'none'} : {'display': 'inherit'}]"></div>
        </v-col>
      </v-row>

      <v-row id="tabContent">
        <v-col sm="12">
          <div id="descDiv" :style="[isDetailDesc ? {'display': 'inherit'} : {'display': 'none'}]">
            <span>{{ containerNFTInfo.desc }}</span>
          </div>
          <div id="attrDiv" :style="[isDetailDesc ? {'display': 'none'} : {'display': 'inherit'}]">
          </div>
        </v-col>
      </v-row>

      <v-btn id="ocBtn" large @click="openContainer()">Open Container</v-btn>
    </div>

    <LoadingModal v-show="isLoadingModalVisible" />
  </div>
</template>

<script>
  import Web3 from 'web3';
  import BigNumber from 'bignumber.js';

  import { sendGetRequest } from '../../utils/axios';
  const containerNFTAbi = require("../../constants/abis/containerNFT.json");
  import LoadingModal from "../../common/LoadingModal/LoadingModal.vue"
  
  export default {
    name: 'ContainerDetail',
    components: {
      LoadingModal,
    },
    emits: ['container-opened'],
    props: {
      containerNFTInfo: Object,
    },
    data: () => ({
      containerNFTContract: '',
      isDetailDesc: true,
      isLoadingModalVisible: false,
    }),
    mounted() {
      this.initialize();
    },
    methods: {
      async initialize() {
        if (typeof window.ethereum === 'undefined') return;

        const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
        this.currentAccount = accounts[0];

        const web3js = window.web3;
        if (typeof web3js === 'undefined') return;

        this.web3 = new Web3(web3js.currentProvider);

        this.web3.eth.defaultAccount = this.currentAccount;

        this.containerNFTContract = this.web3.eth.contract(containerNFTAbi).at(wpData.CONTAINER_NFT_CONTRACT_ADDRESS);
      },
      openContainer() {
        if (this.containerNFTInfo.tokenId == undefined) return;

        let tokenId = new BigNumber(this.containerNFTInfo.tokenId).toNumber();

        this.isLoadingModalVisible = true;

        this.isLoadingModalVisible = true;

        let _this = this;
        this.containerNFTContract.openContainer(tokenId, function(err) {
          if (err) {
            _this.isLoadingModalVisible = false;
            console.log(err.code);
            return;
          }

          _this.containerNFTContract.tokenURI.call(tokenId, function(err, res) {
            if (err) { _this.isLoadingModalVisible = false; console.log(err.code); return; }

            let tokenURI = res;
            sendGetRequest(tokenURI).then(() => {
              _this.isLoadingModalVisible = false;
              location.reload();
            });
          });
        });
      }
    },
    computed: {
    },
  }
</script>

<style scoped>
  p {
    margin: 0px;
    font-family: Architects Daughter;
  }

  span {
    font-family: Architects Daughter;
  }

  .detailed-container {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    border-top-left-radius: 255px 15px;
    border-top-right-radius: 15px 225px;
    border-bottom-right-radius: 225px 15px;
    border-bottom-left-radius: 15px 255px;
    border: solid #881d84 18px;
    box-shadow: 20px 38px 34px -26px #626262;
    -webkit-transition: all .5s ease;
    transition: all .5s ease;
    background: #881d84;
  }

  .content {
    padding: 10px;
    background-color: #131313;
    border-radius: 29px 29px 29px 29px;
  }

  #containerImg {
    width: 100%;
    border-top-left-radius: 29px;
    border-top-right-radius: 29px;
  }

  #nameP {
    width: 100%;
    font-weight: 400;
    font-size: 20px;
    color: #E1DD8F;
    text-align: center;
    margin-top: 20px;
  }

  #ocBtn {
    background-color: #6EC1E4;
    margin-left: auto;
    margin-right: auto;
    text-transform: inherit;
    display: flex;
    margin-top: 20px;
    margin-bottom: 10px;
    font-family: Architects Daughter;
    font-size: 16px;
  }

  #tabRow {
    margin-top: 20px;
    padding: 0px 10px;
  }
  #tabRow .left {
    cursor: pointer;
    position: relative;
  }
  #tabRow .left.active {
    background-color: white;
  }
  #tabRow .left #descP {
    color: #9B544C;
    text-align: center;
    font-weight: 700;
  }
  #tabRow .left #arrowDiv {
    width: 20px;
    height: 20px;
    border-width: 10px;
    border-style: solid;
    border-right-color: transparent;
    border-bottom-color: transparent;
    border-left-color: transparent;
    border-top-color: #e9e9e9;
    position: absolute;
    bottom: -20px;
    left: 50%;
  }
  #tabRow .right {
    cursor: pointer;
    position: relative;
  }
  #tabRow .right.active {
    background-color: white;
  }
  #tabRow .right #attribP {
    color: #9B544C;
    text-align: center;
    font-weight: 700;
  }
  #tabRow .right #arrowDiv {
    width: 20px;
    height: 20px;
    border-width: 10px;
    border-style: solid;
    border-right-color: transparent;
    border-bottom-color: transparent;
    border-left-color: transparent;
    border-top-color: #e9e9e9;
    position: absolute;
    bottom: -20px;
    left: 50%;
  }

  #tabContent {
    padding: 20px;
  }
  #tabContent #descDiv span {
    color: white;
    text-align: center;
    font-size: 14px;
  }
  #tabContent #attrDiv p {
    color: white;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Container/ContainerDetail.vue